import React, { forwardRef, type CSSProperties } from 'react';
import styled from 'styled-components';
import { variables } from '@splunk/themes';
import { _ } from '@splunk/ui-utils/i18n';
import Button from '@splunk/react-ui/Button';
import { noop } from '@splunk/dashboard-utils';

// shares some styling with input enhancer container
const SubmitButtonContainer = styled.div`
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: auto;
    align-items: end;
    box-sizing: border-box;
    border: 1px solid transparent;
    padding: ${variables.spacingSmall};
`;

// extend ButtonProps when SUI properly exports them
export interface SubmitButtonProps {
    disabled?: boolean;
    label?: string;
    onClick?: typeof noop;
    containerStyle?: CSSProperties;
    'data-test'?: string;
}

const SubmitButton = forwardRef<HTMLDivElement, SubmitButtonProps>(
    (
        {
            disabled = false,
            label = _('Submit'),
            onClick = noop,
            containerStyle,
            ...rest
        },
        ref
    ) => {
        return (
            <SubmitButtonContainer ref={ref} style={containerStyle}>
                <Button
                    {...rest}
                    disabled={disabled}
                    label={label}
                    appearance="primary"
                    onClick={onClick}
                />
            </SubmitButtonContainer>
        );
    }
);

export default SubmitButton;
